module.exports = __webpack_public_path__ + "static/media/wally-orange.b349e129.svg";